import styled from 'styled-components';
import { Radio } from 'antd';
import { LabelWrapper } from "../../style";

export const PaymentLabel = styled(LabelWrapper)`
  @media only screen and (min-width: 767px) {
    margin-right: 20px;
  }
`

export const GrantSelectedTabs = styled(Radio.Group)`
  &.ant-radio-group-solid {
      font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
      margin-top: 20px;
      .ant-radio-button-wrapper {
          height: 39px;
          line-height: 39px;
          box-shadow: none;
          border-radius: 0;
          padding: 0 25px;
          color: ${props => props.theme.fontColors.textColor};
          font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
          border-color: ${props => props.theme.border.raeCardFooter};
          &.ant-radio-button-wrapper-checked {
              height: 46px;
              line-height: 46px;
              background: ${props => props.theme.backgroundColor.primaryColor};
              color: ${props => props.theme.colors.white};
              border-color: ${props => props.theme.colors.primaryColor};
              border-radius: 3px;
          }
      }
      // width of tabs are 100% in mobile and fixed in tablet
      @media only screen and (max-width: 576px) {
        width: 100%;
          .ant-radio-button-wrapper {
            width: 50%;
          }
        }
      @media only screen and (min-width: 992px) {
        letter-spacing: ${props => props.theme.letterSpacing.zero};
        margin-top: 0;
      }
  }
`
export const TabsWrapper = styled.div`
  @media only screen and (min-width: 992px) {
    display: flex;
    align-items: center;
  }
`